import { createElement, installComponent } from '../utils/createElement';
import { BREAKPOINTS } from '../utils/breakpoints';
import { COLOR_GRAY_BASE, COLOR_WHITE, COLOR_LIGHT, COLOR_LOGO_FONT, COLOR_LOGO_ICON, COLOR_DARK_2 } from '../utils/colors';
import { closeAllTabs } from '../utils/closeAllTabs';

export default class SideNavHeader extends HTMLElement {
  static get observedAttributes() {
    return ['resourceUrl', 'resource-url'];
  }

  constructor() {
    super();

    // eslint-disable-next-line no-underscore-dangle
    this._expanded = false;

    this.attachShadow({ mode: 'open' });
    this.activatorEvent = this.activatorEvent.bind(this);
  }

  get title() {
    return this.getAttribute('title') || 'ShipBob';
  }

  get resourceUrl() {
    return this.getAttribute('resourceUrl') || this.getAttribute('resource-url');
  }

  get appUrl() {
    return this.getAttribute('appUrl') || '#';
  }

  async connectedCallback() {
    const icon = createElement('div', {
      class: 'sb-sidenav-header__icon',
    });

    icon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 20 23" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M2.74507 10.885V15.9969L9.60114 20.0807L16.4649 15.9969V9.27724L10.613 12.753C9.97071 13.1318 9.23413 13.1318 8.5893 12.753L0.62963 8.01473C-0.2089 7.50972 -0.2089 6.24721 0.62963 5.74994L8.59185 1.00135C9.23413 0.622597 9.97071 0.622597 10.6155 1.00135L16.4674 4.49258L13.7734 6.09262L9.60369 3.61655L7.65392 4.78631L4.12903 6.8965L5.98705 7.99927L9.60624 10.1765L17.0052 5.78086C17.4232 5.53351 17.9941 5.56958 18.4146 5.78859C18.8709 6.03078 19.2098 6.49714 19.2098 7.08975V16.4452C19.2098 17.1744 18.8479 17.8108 18.226 18.1844L10.6181 22.7114C9.98345 23.0979 9.23923 23.0979 8.5944 22.7114L0.983903 18.1792C0.362014 17.8056 0.0077414 17.1795 0.0077414 16.4401V9.25405L2.74507 10.8824V10.885Z" fill="currentColor"/>
    </svg>`;

    const image = createElement(
      'div',
      {
        class: 'sb-sidenav-header__icon-container',
      },
      [
        icon,
      ],
    );
    const title = createElement('h1', { class: 'sb-sidenav-header__title' }, this.title);

    const styles = createElement('style', null, `
      .sb-sidenav-header {
        background-color: ${COLOR_DARK_2};
        display: flex;
      }
      .sb-sidenav-header__container {
        background-color: ${COLOR_DARK_2};
        margin: 1.5rem;
        margin-bottom: 1rem;
        height: 30px;
        display: flex;
        text-decoration: none;
        width: 100%;
        text-align: left;
      }

      .sb-sidenav-header__container-external {
        background-color: ${COLOR_DARK_2};
        background-image: url(${this.resourceUrl});
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        margin: 1.5rem;
        margin-bottom: 1rem;
        height: 45px;
        width: 100%;
        display: flex;
        text-decoration: none;
      }

      .sb-sidenav-header__container-external-svg #document svg {
        height: 100%;
        width: 100%;
      }

      .sb-sidenav-header__activator {
        cursor: pointer;
        display: none;
        width: 4.188rem;
        flex-direction: column;
        justify-content: center;
      }
      .sb-sidenav-header__activator--no-point {
        cursor: default;
      }
      .sb-sidenav-header__activator--expanded > .sb-sidenav-header__activator-line:nth-child(1) {
        transform: translateY(12px) rotate(45deg);
      }
      .sb-sidenav-header__activator--expanded > .sb-sidenav-header__activator-line:nth-child(2) {
        opacity: 0;
      }
      .sb-sidenav-header__activator--expanded > .sb-sidenav-header__activator-line:nth-child(3) {
        transform: translateY(-12px) rotate(-45deg);
      }
      .sb-sidenav-header__activator-line {
        width: 1.25rem;
        height: 1.7px;
        background-color: ${COLOR_GRAY_BASE};
        display: block;
        margin: 2px auto;
        transition: all .3s ease-in-out;
        border-radius: 5px;
      }
      .sb-sidenav-header__title {
        font-family: proxima-nova, sans-serif;
        color: white;
        margin: 0 0 0 0.375rem;
        font-size: 1.3rem;
        line-height: 1.5;
      }
      .sb-sidenav-header__wrapper {
        margin: 0 0 0 0.25rem;
      }
      .sb-sidenav-header__icon-container {
        height: 30px;
        width: 30px;
        overflow: hidden;
      }
      .sb-sidenav-header__icon {
        height: 30px;
      }

      .sb-sidenav-header__icon > svg {
        transition: .5s;
        color: white;
      }

      .sb-sidenav-header__container:hover svg {
        color: ${COLOR_LOGO_ICON};
      }

      @media only screen and (max-width: ${BREAKPOINTS.lg}px) and (min-width: ${BREAKPOINTS.md + 1}px) {
        .sb-sidenav-header__icon-container {
          width: 26px;
          margin: 0 auto;
        }
        .sb-sidenav-header__icon-container, .sb-sidenav-header__icon {
          height: 30px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .sb-sidenav-header__container {
          margin: 1rem;
        }

        .sb-sidenav-header {
          position: absolute;
          width: 100%;
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;
          background-color: ${COLOR_WHITE};
          border-bottom: 1px solid ${COLOR_LIGHT};
          transform: translateX(calc(-100vw + 319px));
        }

        .sb-sidenav-header--expanded {
          transform: translateX(-100vw);
        }

        .sb-sidenav-header__activator {
          display: flex;
        }
        .sb-sidenav-header__container {
          background: ${COLOR_WHITE};
          margin: 1rem;
          width: unset;
        }

        .sb-sidenav-header__title {
          color: ${COLOR_LOGO_FONT};
        }

        .sb-sidenav-header__icon > svg {
          color: ${COLOR_LOGO_ICON};
        }
      }
      @media only screen and (max-width: ${BREAKPOINTS.md}px) {
        .sb-sidenav-header {
          position: absolute;
          width: 100%;
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;
          background-color: ${COLOR_WHITE};
          border-bottom: 1px solid ${COLOR_LIGHT};
        }
        .sb-sidenav-header__activator {
          display: flex;
        }
        .sb-sidenav-header__container {
          background: ${COLOR_WHITE};
          margin: 1rem;
          width: unset;
        }

        .sb-sidenav-header__title {
          color: ${COLOR_LOGO_FONT};
        }

        .sb-sidenav-header__icon > svg {
          color: ${COLOR_LOGO_ICON};
        }
      }
    `);

    const headerSlot = createElement('slot', {});
    const headerWrapper = createElement('div', { class: 'sb-sidenav-header__wrapper' }, [headerSlot]);

    const root = createElement('a', {
      class: this.resourceUrl ? 'sb-sidenav-header__container-external' : 'sb-sidenav-header__container',
      href: this.appUrl,
    }, this.resourceUrl ? [] : [image, title, headerWrapper]);

    const lines = [];
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < 3; i++) {
      lines.push(createElement('div', { class: 'sb-sidenav-header__activator-line' }));
    }
    this.activator = createElement('a', { class: 'sb-sidenav-header__activator' }, lines);

    this.activator.addEventListener('click', this.activatorEvent);

    const activatorMirror = createElement('div', { class: 'sb-sidenav-header__activator sb-sidenav-header__activator--no-point' }, []);
    const wrapper = createElement('div', { class: 'sb-sidenav-header' }, [this.activator, root, activatorMirror]);

    this.shadowRoot.append(wrapper, styles);
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'resourceUrl' || name === 'resource-url') {
      this.shadowRoot.innerHTML = null;
      this.connectedCallback(); // rerender header
    }
  }

  expand() {
    const sideNav = document.querySelector('sb-sidenav')?.shadowRoot?.querySelector('.sb-sidenav');
    sideNav.classList.add('sb-sidenav--expanded');
    const overlay = document.querySelector('sb-sidenav')?.shadowRoot?.querySelector('.sb-sidenav').querySelector('.sb-sidenav__overlay');
    overlay.classList.add('sb-sidenav__overlay--active');
    this.shadowRoot.querySelector('.sb-sidenav-header').classList.add('sb-sidenav-header--expanded');
    this.activator.classList.add('sb-sidenav-header__activator--expanded');
    // eslint-disable-next-line no-underscore-dangle
    this._expanded = true;

    // Hide 'Chat with expert' element
    const chatElement = document?.getElementsByClassName('embeddedServiceHelpButton');
    if (chatElement?.length) {
      chatElement[0].style = 'display:none;';
    }
  }

  activatorEvent(e) {
    if (e) e.preventDefault();
    // eslint-disable-next-line no-underscore-dangle
    this.dispatchEvent(this._event);
    // eslint-disable-next-line no-unused-expressions, no-underscore-dangle
    !this._expanded ? this.expand() : this.collapse();
  }

  collapse() {
    const sideNav = document.querySelector('sb-sidenav')?.shadowRoot?.querySelector('.sb-sidenav');
    sideNav.classList.remove('sb-sidenav--expanded');
    const overlay = document.querySelector('sb-sidenav')?.shadowRoot?.querySelector('.sb-sidenav').querySelector('.sb-sidenav__overlay');
    overlay.classList.remove('sb-sidenav__overlay--active');
    this.shadowRoot.querySelector('.sb-sidenav-header').classList.remove('sb-sidenav-header--expanded');
    this.activator.classList.remove('sb-sidenav-header__activator--expanded');
    // eslint-disable-next-line no-underscore-dangle
    this._expanded = false;
    closeAllTabs();

    // Show 'Chat with expert' element
    const chatElement = document?.getElementsByClassName('embeddedServiceHelpButton');
    if (chatElement?.length) {
      chatElement[0].style = '';
    }
  }

  get _event() {
    return new CustomEvent('toggle-sidenav', { bubbles: true, cancelable: false, composed: true });
  }
}
installComponent('sb-sidenav-header', SideNavHeader);
